import posthog from "posthog-js";

const PII_KEYS = new Set([
    "email",
    "name",
    "cuit",
    "cuil",
    "cbu",
    "cvu",
    "phone",
    "wallet",
    "walletAddress",
    "wallet_address",
    "address",
    "dni",
    "holderName",
    "holder_name",
    "alias",
    "cuilCuit",
    "cuil_cuit",
    "cbuCvu",
    "cbu_cvu",
    "$ip",
]);

const EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const CBU_CVU_RE = /\b\d{22}\b/g;
const CUIT_CUIL_DASHED_RE = /\b\d{2}-\d{8}-\d\b/g;
const CUIT_CUIL_PLAIN_RE = /\b(?:20|23|27|30|33|34)\d{9}\b/g;
const WALLET_RE = /0x[a-fA-F0-9]{40}/g;

function redactString(value: string): string {
    return value
        .replace(EMAIL_RE, "[REDACTED_EMAIL]")
        .replace(CBU_CVU_RE, "[REDACTED_CBU]")
        .replace(CUIT_CUIL_DASHED_RE, "[REDACTED_CUIT]")
        .replace(WALLET_RE, "[REDACTED_WALLET]")
        .replace(CUIT_CUIL_PLAIN_RE, "[REDACTED_CUIT]");
}

function cleanObject(obj: Record<string, any>): Record<string, any> {
    const cleaned: Record<string, any> = {};
    for (const key of Object.keys(obj)) {
        if (PII_KEYS.has(key)) continue;
        const val = obj[key];
        if (typeof val === "string") {
            cleaned[key] = redactString(val);
        } else {
            cleaned[key] = val;
        }
    }
    return cleaned;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function sanitizePII(event: any): any {
    if (event.properties) {
        event.properties = cleanObject(event.properties);
    }
    if (event.$set) {
        event.$set = cleanObject(event.$set);
    }
    return event;
}

export function initPostHog(): void {
    const key = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
    if (!key) return;

    posthog.init(key, {
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://eu.i.posthog.com",
        person_profiles: "identified_only",
        autocapture: true,
        capture_pageview: false,
        capture_pageleave: true,
        session_recording: {
            maskAllInputs: true,
            maskTextSelector: "[data-ph-mask]",
        },
        before_send: sanitizePII,
    });
}

export { posthog };
